import { z } from 'zod';
import { LocationType } from '../../constants/location-type.js';
import { locationDescriptionSchema, locationNameSchema } from './update-form.js';
export const updateLocationInputSchema = z
    .object({
    name: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
    typeId: z.enum(LocationType, 'Invalid location type selection.').optional().nullable(),
    pickable: z.boolean().optional().nullable(),
    receivable: z.boolean().optional().nullable(),
    countedAsAvailable: z.boolean().optional().nullable(),
})
    .superRefine((input, context) => {
    if (input.name !== undefined) {
        const nameResult = locationNameSchema.safeParse(input.name ?? '');
        if (!nameResult.success) {
            context.addIssue({
                code: 'custom',
                message: nameResult.error.issues[0].message,
                path: ['name'],
            });
        }
    }
    if (input.description !== undefined) {
        const descriptionResult = locationDescriptionSchema.safeParse(input.description ?? '');
        if (!descriptionResult.success) {
            context.addIssue({
                code: 'custom',
                message: descriptionResult.error.issues[0].message,
                path: ['description'],
            });
        }
    }
});
//# sourceMappingURL=update-input.js.map